<template>
  <div>
    <label>{{ mytitle }}</label>
    <div>
    <div v-show="type == 'text'" class='col-lg-3 col-md-3 col-sm-3 col-xm-3' style="padding:0px;text-align:center">
        <input :disabled="disabled" :type="type" ref ="myDay" :value='myDay' @input ='updateDay($event.target.value)' class="form-control" maxlength="2" style="padding:0px;margin:0px;text-align:center" @keypress="isNumber($event,'day')">
    </div>
    <div class='col-lg-3 col-md-3 col-sm-3 col-xm-3' style="padding:0px;text-align:center">
      <input :disabled="disabled" ref ="myMonth" @input ='updateMonth($event.target.value)' class="form-control" v-model="myMonth" maxlength="2" style="padding:0px;margin:0px;text-align:center" @keypress="isNumber($event,'month')">
    </div>
    <div class='col-lg-6 col-md-6 col-sm-6 col-xm-6' style="padding:0px;text-align:center">
      <input :disabled="disabled" ref ="myYear" @input ='updateYear($event.target.value)' class="form-control" v-model="myYear" maxlength="4" style="padding:0px;margin:0px;text-align:center" @keypress="isNumber($event,'year')">
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'tbDate',
  props: {
    myformat: {
      default: 'text'
    },
    disabled: {
      default: false
    },
    mytitle: {
      default: ''
    },
    value: {
      default: ''
    },
    today: {
      default: false
    }
  },
  watch: {
    value (newVal, oldVal) { // watch it
      if (this.value) {
        let xDate = this.value.split('-')
        this.myYear = xDate[0]
        this.myMonth = xDate[1]
        this.myDay = xDate[2]
        let tt = this.myYear + '-' + this.myMonth + '-' + this.myDay
        if (tt === '--') {
          tt = ''
        }
        this.$emit('input', tt)
      } else {
        this.myYear = ''
        this.myMonth = ''
        this.myDay = ''
      }
    }
  },
  data () {
    return {
      type: 'text',
      myDay: '',
      myMonth: '',
      myYear: ''
    }
  },
  created () {
    if (this.today) {
      var today = new Date()
      this.myDay = String(today.getDate()).padStart(2, '0')
      this.myMonth = String(today.getMonth() + 1).padStart(2, '0')
      this.myYear = today.getFullYear()
      let tt = this.myYear + '-' + this.myMonth + '-' + this.myDay
      this.$emit('input', tt)
    }
    if (this.myformat === 'month') {
      this.type = 'hidden'
      this.myDay = 1
    }
    if (this.value) {
      let xDate = this.value.split('-')
      this.myYear = xDate[0]
      this.myMonth = xDate[1]
      this.myDay = xDate[2]
      let tt = this.myDay + '-' + this.myMonth + '-' + this.myYear
      this.$emit('input', tt)
    }
  },
  methods: {
    updateDay (value) {
      this.myDay = value
      let tt = this.myYear + '-' + this.myMonth + '-' + this.myDay
      this.$emit('input', tt)
    },
    updateMonth (value) {
      this.myMonth = value
      let tt = this.myYear + '-' + this.myMonth + '-' + this.myDay
      this.$emit('input', tt)
    },
    updateYear  (value) {
      this.myYear = value
      let tt = this.myYear + '-' + this.myMonth + '-' + this.myDay
      this.$emit('input', tt)
    },
    isNumber (evt, eliID) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        if (charCode === 13 && eliID === 'day') {
          this.$refs.myMonth.select()
        }
        if (charCode === 13 && eliID === 'month') {
          this.$refs.myYear.select()
        }
        return true
      }
    }

  }
}
</script>

//  <tbDate  :mytitle='dateTitle' :today='today' :myformat='month'  v-model= 'record.date' ></tbDate>



// WEBPACK FOOTER //
// src/components/myComponents/tbDate.vue